import { __module as getProp } from "../../../../../../../_virtual/getProp.js";
var hasRequiredGetProp;
function requireGetProp() {
  if (hasRequiredGetProp) return getProp.exports;
  hasRequiredGetProp = 1;
  (function(module, exports$1) {
    exports$1.__esModule = true;
    exports$1["default"] = getProp2;
    function getProp2(obj) {
      for (var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        props[_key - 1] = arguments[_key];
      }
      while (props.length > 0) {
        var prop = props.shift();
        if (!obj[prop]) {
          return void 0;
        }
        obj = obj[prop];
      }
      return obj;
    }
    module.exports = exports$1.default;
  })(getProp, getProp.exports);
  return getProp.exports;
}
export {
  requireGetProp as __require
};
//# sourceMappingURL=getProp.js.map
